import { Pipe, PipeTransform } from '@angular/core';
import { DashboardComponent } from 'src/app/lckr/dashboard/dashboard.component';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  constructor(private comp:DashboardComponent){
  }
  transform(value: any,term?: any): any {
    if( term === undefined) return value;
    this.comp.onTableDataChange();
    return value.filter(function(activity:any){
      return activity.title.toLowerCase().includes(term.toLowerCase());
    }) 

  }

}
